import { render, staticRenderFns } from "./Bootstrap.vue?vue&type=template&id=00b3e010&scoped=true&"
import script from "./Bootstrap.vue?vue&type=script&lang=js&"
export * from "./Bootstrap.vue?vue&type=script&lang=js&"
import style0 from "./Bootstrap.vue?vue&type=style&index=0&id=00b3e010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3e010",
  null
  
)

export default component.exports